import React from 'react'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton/index'
import { Formik } from 'formik'
import * as yup from 'yup'
import axios from '../../Utils/Utility/axiosconfig'
import Swal from 'sweetalert2'
import AuthContainer from '../../components/organisms/AuthContainer'
import './resetpassword.css'
import { useHistory } from 'react-router-dom'

const ResetPassword = (props) => {
    const resetPassSchema = yup.object({
        email: yup.string().email('Invalid email format').required('Required!'),
    })
    const history = useHistory()

    const resetPass = async (values) => {
        console.log('asdasdas')
        try {
            const data = {
                email: values.email,
            }
            const res = await axios.post('mobileapi/forgot_password', data)
            if (res.data.success === 'yes') {
                Swal.fire({
                    icon: 'success',
                    title: 'Reset Link sent to Mail',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                history.push({ pathname: '/login' })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.message,
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <AuthContainer authPage="signup-page">
            <Formik
                initialValues={{ email: '' }}
                validationSchema={resetPassSchema}
                onSubmit={(values) => {
                    resetPass(values)
                }}
            >
                {({ errors, touched, values, handleChange, handleBlur, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="resetPassword-text">
                            <h1 className="auth-title">Reset Password</h1>
                        </div>
                        <CustomInput
                            label="Email Address"
                            variant="standard"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="email"
                            value={values.email}
                            placeholder="Enter your email"
                        />
                        {errors.email && touched.email ? (
                            <div className="ResetpassError">{errors.email}</div>
                        ) : null}
                        <PrimaryButton label="Send Reset Password Link" type="submit" />
                        <div className="bottomText">
                            <a href="/login">Sign in Instead</a>
                        </div>
                    </form>
                )}
            </Formik>
        </AuthContainer>
    )
}

export default ResetPassword
